/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ServiceCalendarSettingsLeadTimeDaysEnum =
  (typeof ServiceCalendarSettingsLeadTimeDaysEnum)[keyof typeof ServiceCalendarSettingsLeadTimeDaysEnum];

export const ServiceCalendarSettingsLeadTimeDaysEnum = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_5: 5,
  NUMBER_7: 7,
  NUMBER_14: 14,
} as const;
